module.exports = __webpack_public_path__ + "img/illustrations/drag-and-drop-csv-4be30918ae56de3041f273944ef8a8e7.svg";